// BOORO: the log. What the agents and the people of a space did, with the
// costs of it. The log holds no content, only short descriptions.
import { oc } from "@orpc/contract";
import * as z from "zod";
import { Id } from "./ids.js";

/** The kinds of entry the log holds. */
export const AUDIT_KINDS = ["task", "run", "action", "decision"] as const;
export type AuditKind = (typeof AUDIT_KINDS)[number];

export const AuditEntrySchema = z.object({
  id: z.string(),
  at: z.string(),
  kind: z.enum(AUDIT_KINDS),
  /** The person or the agent that did it. */
  actor: z.string(),
  actorKind: z.enum(["person", "agent"]),
  botId: Id.nullable(),
  botName: z.string().nullable(),
  /** What happened, in one line. */
  action: z.string(),
  taskId: Id.nullable(),
  taskRef: z.string().nullable(),
  taskTitle: z.string().nullable(),
  outcome: z.string().nullable(),
  /** What it cost; null when a price is unknown. */
  costUsd: z.number().nullable(),
});
export type AuditEntry = z.infer<typeof AuditEntrySchema>;

export const AuditListInput = z.object({
  /** How far back the log goes; days. */
  days: z.number().int().min(1).max(365).default(30),
  botId: Id.optional(),
  kinds: z.array(z.enum(AUDIT_KINDS)).optional(),
  cursor: z.string().max(400).optional(),
});
export type AuditListInput = z.infer<typeof AuditListInput>;

export const AuditListSchema = z.object({
  entries: z.array(AuditEntrySchema),
  /** The cursor of the next page; null when the log ends here. */
  cursor: z.string().nullable(),
});
export type AuditList = z.infer<typeof AuditListSchema>;

export const booroAuditContract = {
  list: oc.input(AuditListInput).output(AuditListSchema),
  /** The log of the same view as CSV, for Excel. */
  exportCsv: oc.input(AuditListInput).output(z.object({ csv: z.string() })),
  /** Whether the person may read the log, so the menu only offers it then. */
  allowed: oc.output(z.object({ allowed: z.boolean() })),
};
